import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../assets/images/add.svg";
import FilterComponent from "../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeactivateSvg } from "../../../assets/images/action/deactivate.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import CommonFilter from "../../../components/common/filter";
import { useDispatch, useSelector } from "react-redux";
import useSelection from "antd/es/table/hooks/useSelection";
import {
  deleteTenantFun,
  listTenantFun,
  updateTenantFun,
} from "../../../redux/reducer/TenantSlice";
import dayjs from "dayjs";
import trimSearchValue, { useDebounce } from "../../../customHooks";
import { useSearchParams } from "react-router-dom";

const TenantMgmnt = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const [refereshData, setRefereshData] = useState(false);
  const [disableId, setDisableId] = useState(null);
  const [disableStatus, setDisableStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // const [tableParams, setTableParams] = useState({
  //   page: 1,
  //   size: 10,
  //   search_value: "",
  //   search_key: "",
  //   status: undefined,
  //   position: undefined,
  // });

  // set page refersh
  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const position = searchParams.get("position");
    const from_date = searchParams.get("from_date");
    const to_date = searchParams.get("to_date");

    return {
      page,
      size,
      search_key,
      search_value,
      // from_date,
      // to_date,
      status: status !== null ? Number(status) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };

    if (tableParams.status !== undefined) params.status = tableParams.status;
    if (tableParams.position !== undefined)
      params.position = tableParams.position;
    if (tableParams.from_date !== undefined)
      params.from_date = tableParams.from_date;
    if (tableParams.to_date !== undefined) params.to_date = tableParams.to_date;

    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  // set page refersh end

  const dispatch = useDispatch();
  const { listTenant, listTenantCount, listTenantLoading } = useSelector(
    (prev) => prev?.tenant
  );

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    dispatch(listTenantFun(trimSearchValue(tableParams)));
  }, [
    refereshData,
    tableParams.page,
    tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.from_date,
    tableParams.to_date,
  ]);

  // pagination

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: listTenantCount || 1,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource.filter((item) => {
      const itemDate = new Date(item.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
      width: "100px",
    },
    {
      title: "Tenant Name",
      dataIndex: "name_en",
      type: "search",
      key: "name_en",
      width: "150px",
    },
    // {
    //   title: "Subscription Start - End Date",
    //   dataIndex: "start",
    //   key: "start",
    //   type: "date",
    //   render: (date) => `dayjs(date).format("DD-MM-YYYY")`,
    // },
    {
      title: "Subscription Start - End Date",
      dataIndex: "subscription_start_date",
      key: "subscription_period",
      render: (_, record) => {
        const startDate = new Date(record.subscription_start_date);
        const endDate = new Date(record.subscription_end_date);

        const startDay = String(startDate.getUTCDate()).padStart(2, "0");
        const startMonth = String(startDate.getUTCMonth() + 1).padStart(2, "0");
        const startYear = startDate.getUTCFullYear();

        const endDay = String(endDate.getUTCDate()).padStart(2, "0");
        const endMonth = String(endDate.getUTCMonth() + 1).padStart(2, "0");
        const endYear = endDate.getUTCFullYear();

        return `${startMonth}-${startDay}-${startYear} - ${endMonth}-${endDay}-${endYear}`;
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      type: "search",
    },
    {
      title: "Max User Allowed",
      dataIndex: "max_user",
      key: "max_user",
      // type: "search",
      width: "150px",
    },
    {
      title: "Total Users",
      dataIndex: "total_user",
      key: "total_users",
      // type: "search",
      width: "120px",
      render: (total_user) => (total_user ? total_user : "0"),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   type: "select",
    //   options: [
    //     { label: "Active", value: "Active" },
    //     { label: "Inactive", value: "Inactive" },
    //   ],
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      width: "90px",
      render: (status) =>
        status === 1 ? (
          <p className="active-status">Active</p>
        ) : (
          <p className="inactive-status">Inactive</p>
        ), // Check if status is 1
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "date",
      type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, "0");
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0");
        const year = dateObject.getUTCFullYear();
        return `${month}-${day}-${year}`;
      },
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      tenant_name: "Acme Corp",
      start: "2024-01-01 - 2025-01-01",
      email: "contact@acme.com",
      total_users: 50,
      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      tenant_name: "Tech Solutions",
      start: "2023-05-10 - 2024-05-10",
      email: "info@techsolutions.com",
      total_users: 120,
      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      tenant_name: "Innovate Inc.",
      start: "2024-03-01 - 2025-03-01",
      email: "support@innovate.com",
      total_users: 80,
      status: "Active",
      date_added: "2024-03-01",
    },
    {
      key: "4",
      sr_no: "4",
      tenant_name: "NextGen Systems",
      start: "2023-08-20 - 2024-08-20",
      email: "admin@nextgensys.com",
      total_users: 200,
      status: "Pending",
      date_added: "2023-08-20",
    },
    {
      key: "5",
      sr_no: "5",
      tenant_name: "Cloud Services Ltd",
      start: "2024-06-15 - 2025-06-15",
      email: "hello@cloudservices.com",
      total_users: 60,
      status: "Active",
      date_added: "2024-06-15",
    },
    {
      key: "6",
      sr_no: "6",
      tenant_name: "Enterprise Hub",
      start: "2023-11-05 - 2024-11-05",
      email: "enterprise@hub.com",
      total_users: 90,
      status: "Inactive",
      date_added: "2023-11-05",
    },
  ];
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete"); // Open the modal
  };

  const handleDisableClick = (id, status) => {
    if (status === 1) {
      showModal("disable", id, status);
    } else if (status === 0) {
      showModal("enable", id, status);
    } else {
    }
    setDisableStatus(status);
    setDisableId(id);
    // showModal("disable"); // Open the modal for confirmation
  };

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deleteTenantFun(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(updateTenantFun({ id: disableId, data: { status: 0 } }));
      } else if (modalConfig.actionType === "enable") {
        await dispatch(updateTenantFun({ id: disableId, data: { status: 1 } }));
      }
    } catch (error) {
      console.error("Action failed:", error);
    } finally {
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };

  // const handleConfirm = async () => {
  //   if (modalConfig.actionType === "delete" && deleteId) {
  //     try {
  //       await dispatch(deleteTenantFun(deleteId));
  //       setRefereshData((prev) => !prev)
  //       setDeleteId(null);
  //     } catch (error) {
  //       console.error("Failed to delete subscription:", error);
  //     }
  //   }
  //   closeModal();
  // };

  const handleEdit = (record) => {
    navigate("edit-tenant", { state: { tenentData: record } });
  };

  const actionItems = (record) => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),
      // onClick: (record) => navigate("view-tenant"),
      onClick: (record) =>
        navigate("view-tenant", { state: { tenantData: record } }),
    },
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      // onClick: () => navigate("add-tenant"),
      onClick: (record) => handleEdit(record),
    },
    {
      key: "deactivate",
      label: (
        <>
          <DeactivateSvg style={{ marginRight: 8, color: "red" }} />
          {record.status === 1 ? "Disable" : "Enable"}
        </>
      ),
      // onClick: () => showModal("deactivate"),
      onClick: (record) => handleDisableClick(record?.id, record?.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Tenant
        </>
      ),
      // onClick: () => showModal("delete"),
      onClick: (record) => handleDeleteClick(record.id),
    },
  ];
  // const handleFilterChange = (key, value, reset = false) => {
  //   setTableParams((prev) => {
  //     if (reset) {
  //       return {
  //         ...prev,
  //          page: 1,
  //         search_key: "",
  //         search_value: "",
  //         status: undefined,
  //         position: undefined,
  //       };
  //     }
  //     if (key === "status" || key === "position") {
  //       return {
  //         ...prev,
  //          page: 1,
  //         [key]: value,
  //         search_key: "",
  //         search_value: "",
  //       };
  //     }
  //     return {
  //       ...prev,
  //        page: 1,
  //       search_key: key,
  //       search_value: value,
  //       status: undefined,
  //       position: undefined,
  //     };
  //   });
  // };

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "all",
          search_value: "",
          status: undefined,
          position: undefined,
          from_date: undefined,
          to_date: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
          // search_key: "",
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "all",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value.from_date,
          to_date: value.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };

  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-tenant")}
        >
          Add Tenant
        </Button>
      </div>
      <div className="tableHeading">List of Tenants Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listTenant ?? []}
        loading={listTenantLoading}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
        // actionItems={actionItems}
        actionItems={(record) => actionItems(record)}
      />
      <ConfirmModal
        titlePrefix="Tenant"
        messagePrefix="Tenant"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default TenantMgmnt;
